import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/dataStorage.js'

// 默认配置
axios.defaults.timeout = 60000;
axios.defaults.responseType = 'json';
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';

Vue.prototype.int = 0;

// 请求拦截
axios.interceptors.request.use(function(config) {
    // 在发送请求之前做些什么
    config.headers.token = getToken();
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 相应拦截
axios.interceptors.response.use(function(response) {
    // 对响应数据做点什么
    return response;
}, function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

/**
 * post请求
 * @param url url
 * @param data 请求数据
 * @param isLoading 是否loading遮挡 默认false
 * @param loadingText loading提示语
 * @returns {Promise<unknown>}
 */
Vue.prototype.$post = function(url, data, isLoading, loadingText) {
    let loading;
    if (isLoading) {
        loading = this.$loading({
            lock: true,
            text: loadingText ? loadingText : '处理中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    }

    let _this = this;
    let promise = new Promise((resolve, reject) => {
        axios.post(url, data)
            .then((response) => {
                checkOk(response,resolve,reject,_this)
                if (isLoading) {
                    loading.close();
                }
            }).catch((error) => {
                Message.error('发生错误...');
                reject(error);
            });
    });
    return promise;
};

Vue.prototype.$get = function(url, data) {
    let _this = this;
    let promise = new Promise((resolve, reject) => {
        axios.get(url, data)
            .then((response) => {
                checkOk(response,resolve,reject,_this)
            }).catch((error) => {
                Message.error('发生错误...');
            });
    });
    return promise;
};


 function checkOk(response,resolve, reject,_this) {

    if (response.status === 200) {
        let data = response.data;
        //如果code == 10000 表示业务处理成功
        if(data.code == "10000"){
            _this.int = 0;
            resolve(data.data)
            return;
        }
        //检测登录状态，如果返回true，跳转至登录页面
        if (checkLogin(data)) {
            if(_this.int === 0){
                Message.warning("登录失效");
                _this.int = 1;
            }
            _this.$router.push('/login')
            return;
        }
        //其他状态 全局提示
        Message.info(data.info);

        //如果其他状态，则直接放入catch中
        reject(data);
    }else{
        reject(error);
    }
}


/**
 * 检测接口返回的登录状态。
 * @param resp
 * @returns {boolean} true = 登录状态已经失效，需要返回登录页面  false =  不进行操作
 */
let checkLogin = function(resp) {
    let checkLogin = false;

    if(resp.code == "20002"){
        //登录失效
        checkLogin = true;
    } else if(resp.code == "20003"){
        //账号在其他设备登录
        checkLogin = true;
    }
    if(checkLogin){
        //删除token
        removeToken();
    }
    return checkLogin;
}

// 定义公共方法，下载Excel
const download = (url, data, fileName) => {
    return axios({
        baseURL: process.env.VUE_APP_BASE_API,
        method: 'post',
        url,
        // headers里面设置token
        headers: {
            'token': getToken()
        },
        data,
        // 二进制流文件，一定要设置成blob，默认是json
        responseType: 'blob'
    }).then(res => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    })
}

// 定义公共方法，预览
const downloadPdf = (url, data) => {
    return axios({
        baseURL: process.env.VUE_APP_BASE_API,
        method: 'post',
        url,
        // headers里面设置token
        headers: {
            'token': getToken()
        },
        data,
        // 二进制流文件，一定要设置成blob，默认是json
        responseType: 'blob'
    }).then(res => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/pdf' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.target = '_blank '
        link.click()
        document.body.removeChild(link)
    })
}